import React from 'react';
import {
  NavigableSwitch,
  Route,
  Failover,
} from 'Components/UI/FacetRouter/FacetRouter';
import Expense from 'Components/Universal/Questionnaire/Screens/Expense';
import Liabilities from 'Components/Universal/Questionnaire/Screens/Liabilities';
import FinancialProfile from 'Components/Universal/Questionnaire/Screens/FinancialProfile';
import Goals from 'Components/Universal/Questionnaire/Screens/Goals';
import OtherAdvisors from 'Components/Universal/Questionnaire/Screens/OtherAdvisors';
import EstatePlanning from 'Components/Universal/Questionnaire/Screens/EstatePlanning';
import SSIAndPensions from 'Components/Universal/Questionnaire/Screens/SSIAndPensions';
import Insurance from 'Components/Universal/Questionnaire/Screens/Insurance';
import IncomeDetails from 'Components/Universal/Questionnaire/Screens/IncomeDetails';
import {
  goals,
  incomeDetails,
  ssiAndPensions,
  liabilities,
  insurance,
  estatePlanning,
  financialProfile,
  otherAdvisors,
  expense,
} from 'Components/Universal/Questionnaire/RoutePaths';
import {
  goalsObjectivesAndInterestsHref,
  ssiAndPensionsHref,
  liabilitiesHref,
  estatePlanningHref,
  financialProfileHref,
  otherAdvisorsHref,
  expenseHref,
  insuranceHref,
  incomeDetailsHref,
} from 'Consts/clientUris';
import './index.css';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import fr from 'facet-rest';

function getQuestionnaireRoutesForClient(householdResource) {
  const goalsRoute = householdResource.withRelationship(fr.relationships.goalsPage.name,
    () => [],
    () => [
      <Route
        path={goals}
        component={Goals}
        title="Goals"
        test="goals"
        href={goalsObjectivesAndInterestsHref}
      />,
    ]);

  const allRoutes = [
    ...goalsRoute,
    <Route
      path={incomeDetails}
      component={IncomeDetails}
      title="Income Details"
      test="income"
      href={incomeDetailsHref}
    />,
    <Route
      path={ssiAndPensions}
      component={SSIAndPensions}
      title="SSI & Pensions"
      test="ssi"
      href={ssiAndPensionsHref}
    />,
    <Route
      path={liabilities}
      component={Liabilities}
      title="Credit Score"
      test="liabilities"
      href={liabilitiesHref}
    />,
    <Route
      path={insurance}
      component={Insurance}
      title="Insurance"
      test="insurance"
      href={insuranceHref}
    />,
    <Route
      path={estatePlanning}
      component={EstatePlanning}
      title="Estate Planning"
      test="estate"
      href={estatePlanningHref}
    />,
    <Route
      path={financialProfile}
      component={FinancialProfile}
      title="Financial Profile"
      test="financial"
      href={financialProfileHref}
    />,
    <Route
      path={otherAdvisors}
      component={OtherAdvisors}
      title="Other Advisors"
      test="other"
      href={otherAdvisorsHref}
    />,
    <Route
      path={expense}
      component={Expense}
      title="Expenses"
      test="expenses"
      href={expenseHref}
    />,
  ];
  return allRoutes;
}

const Questionnaire = () => {
  const { householdResource } = useSimpleHousehold();
  useScrollTopOnMount();

  const failoverRoute = householdResource.withRelationship(fr.relationships.goalsPage.name,
    () => incomeDetailsHref,
    () => goalsObjectivesAndInterestsHref);

  return (
    <NavigableSwitch>
      {getQuestionnaireRoutesForClient(householdResource)}
      <Failover to={failoverRoute} />
    </NavigableSwitch>
  );
};

Questionnaire.propTypes = {
};

Questionnaire.defaultProps = {
};

export default Questionnaire;
